import React from 'react';
import { styled } from '@compiled/react';
import { Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from '@atlassian/jira-intl';
import messages from './messages.tsx';

// Common UI element for the Epic Link and Parent Link fields indicating that they should not be used
// and instead the user should use the Parent field to set the parent of an issue
export const DisabledEpicLinkParentLinkField = () => (
	<DisabledEpicLinkParentLinkFieldWrapper>
		<FormattedMessage
			{...messages.replacedByParentField}
			values={{
				strong: (chunks) => <Text as="strong">{chunks}</Text>,
			}}
		/>
	</DisabledEpicLinkParentLinkFieldWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisabledEpicLinkParentLinkFieldWrapper = styled.span({
	whiteSpace: 'pre-wrap',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest'),
});
